"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (slug) {
  return slug.replace(/[-_]/ig, " ");
};